import API_BASE from '../../utils/api';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Sidebar from '../../components/Sidebar';
import ProfileDropdown from '../../components/ProfileDropdown';

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const MONTH_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const TeacherHolidays = () => {
  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_BASE}/events?upcoming=false`)
      .then(res => {
        const holidayList = (res.data || []).filter(e => e.eventType === 'holiday' && e.visibleToTeachers);
        setHolidays(holidayList);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const formatDate = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    return `${DAYS[d.getDay()]}, ${d.getDate()} ${MONTH_SHORT[d.getMonth()]} ${d.getFullYear()}`;
  };

  const isUpcoming = (iso) => new Date(iso) >= new Date(new Date().setHours(0, 0, 0, 0));

  const upcoming = holidays.filter(h => isUpcoming(h.eventDate));
  const past = holidays.filter(h => !isUpcoming(h.eventDate));

  const Section = ({ title, items }) => (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <div className="px-5 py-3 border-b bg-gray-50">
        <h3 className="font-semibold text-gray-700">{title} <span className="text-sm text-gray-400 font-normal">({items.length})</span></h3>
      </div>
      {items.length === 0 ? (
        <p className="px-5 py-8 text-center text-gray-400 text-sm">None</p>
      ) : (
        <div className="divide-y">
          {items.map(holiday => {
            const d = new Date(holiday.eventDate);
            return (
              <div key={holiday._id} className="flex items-center px-5 py-4 gap-4 hover:bg-gray-50">
                <div className={`shrink-0 w-14 h-14 rounded-xl flex flex-col items-center justify-center ${isUpcoming(holiday.eventDate) ? 'bg-indigo-100' : 'bg-gray-100'}`}>
                  <span className={`text-xl font-bold ${isUpcoming(holiday.eventDate) ? 'text-indigo-700' : 'text-gray-500'}`}>{d.getDate()}</span>
                  <span className={`text-xs ${isUpcoming(holiday.eventDate) ? 'text-indigo-500' : 'text-gray-400'}`}>{MONTH_SHORT[d.getMonth()]}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-gray-900">{holiday.title}</p>
                  <p className="text-sm text-gray-500">{formatDate(holiday.eventDate)}</p>
                  {holiday.description && <p className="text-xs text-gray-400 mt-0.5 truncate">{holiday.description}</p>}
                </div>
                {isUpcoming(holiday.eventDate) && (
                  <span className="shrink-0 text-xs bg-indigo-100 text-indigo-700 px-2 py-0.5 rounded-full font-medium">Upcoming</span>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );

  return (
    <div className="flex h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1 overflow-auto">
        <nav className="bg-white shadow-sm sticky top-0 z-10">
          <div className="px-6 py-4 flex justify-between items-center">
            <div>
              <h1 className="text-2xl font-semibold text-gray-800">Holiday Calendar</h1>
              <p className="text-sm text-gray-500">School holidays shared by the administration</p>
            </div>
            <ProfileDropdown />
          </div>
        </nav>

        <div className="p-6 space-y-4">
          {loading ? (
            <div className="bg-white rounded-lg shadow p-8 text-center">
              <div className="flex justify-center items-center gap-2 text-gray-500">
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-indigo-600"></div>
                Loading...
              </div>
            </div>
          ) : holidays.length === 0 ? (
            <div className="bg-white rounded-lg shadow p-12 text-center text-gray-500">
              <div className="text-5xl mb-3">📅</div>
              <p className="font-medium">No holidays published yet</p>
              <p className="text-sm mt-1">Your administration will publish the holiday calendar here</p>
            </div>
          ) : (
            <>
              <Section title="Upcoming Holidays" items={upcoming} />
              {past.length > 0 && <Section title="Past Holidays" items={past} />}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TeacherHolidays;
